import { formattedDate3 } from '../../../../helper/utils/formattedDate';
import { isEmptyObject } from '../../../../helper/utils/isEmptyObject';
import { StayOnPageTracker } from '../../../layout/StayOnPageTracker';
import FloatingCheckoutButton from '../../components/FloatingCheckoutButton';
import ProductList from '../../components/ProductList';
import ProductsOverview from '../../components/ProductsOverview';
import useOnlineSales from '../../hooks/useOnlineSales';
import usePages from '../../hooks/usePages';
import HeroSection from './components/Hero';

export default function HomePage() {
    const { outlet, page, productType } = usePages();
    const { groupedData, loadingOrder, selectedDate, handleGetProductAvailability } = useOnlineSales();

    return (
        <>
            <StayOnPageTracker />
            <HeroSection home={page['home'] || {}} outlet={outlet || {}} />
            {!isEmptyObject(page) && (
                <ProductsOverview
                    id='product-overview'
                    products={groupedData}
                    type={productType || 'ticketing'}
                    overview={page['sales'] || {}}
                    isLoading={loadingOrder}
                    onGetProducts={() => {
                        if (selectedDate) {
                            handleGetProductAvailability('ticketing', formattedDate3(selectedDate));
                        }
                    }}
                />
            )}
            <FloatingCheckoutButton />
            {!isEmptyObject(page) && <ProductList product={page['products'] || {}} />}
        </>
    );
}
